"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileNavigation = void 0;
var theme_ui_1 = require("theme-ui");
var IconButton_1 = require("../../atoms/IconButton/IconButton");
var MobileDropdown_1 = require("../../atoms/MobileDropdown");
var burger_menu_svg_1 = __importDefault(require("../../styles/Icons/assets/burger-menu.svg"));
var MobileNavigation = function (_a) {
    var menuItems = _a.menuItems, isMenuOpen = _a.isMenuOpen, toggleMenu = _a.toggleMenu;
    return (theme_ui_1.jsx(theme_ui_1.Flex, null,
        theme_ui_1.jsx(IconButton_1.IconButton, { csx: { width: 24, height: 26 }, icon: burger_menu_svg_1.default, onClick: toggleMenu }),
        theme_ui_1.jsx(MobileDropdown_1.MobileDropdown, { isOpen: isMenuOpen, menuPosition: { top: 88, right: 0, } },
            theme_ui_1.jsx(MobileDropdown_1.DropdownContent, { alignItems: 'right' }, menuItems.map(function (_a) {
                var href = _a.href, text = _a.text, onClick = _a.onClick;
                return (theme_ui_1.jsx(MobileDropdown_1.DropdownLink, { onClick: onClick, href: href, key: text }, text));
            })))));
};
exports.MobileNavigation = MobileNavigation;
